// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"207b83ef","312":"22880ff7","358":"980febcf","427":"24dd7aae","453":"58583e03","457":"4d370420","551":"aaa9d4c4","643":"0f978b27","828":"4d10c859"}[chunkId] + ".chunk.js";
};